import { CreateAppointmentViewModel } from './../business-entities/create-appointment-view-model.interface';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Injectable } from '@angular/core';
import { Urls } from './../utils/urls';
import { FileUploadModel } from 'projects/Autofacets-Core/src/app/business-entities/document-model';

@Injectable({providedIn: 'root'})
export class AppointmentDataService {
    constructor(
        private dataService: DataService
    ) {}

    CreateAppointment(model: CreateAppointmentViewModel): Promise<GenericResponse<any>> {
        let files: FileUploadModel[] = [];
        model.CustomerDocuments.forEach(demand => {
            let index = 0;
            demand.Documents.forEach(doc => {
                files.push({
                    uniqueId: "file_"+ demand.uniqueId +"_" + index,
                    file: doc.actualFile
                });
                doc.imageBinaryData = "";
                index++;
            });
        });
        return this.dataService.PostFiles<GenericResponse<any>>(Urls.CreateAppointment, model, files).toPromise();
    }
    VerifyOTP(model: any): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.VerifyOTP, model).toPromise();
    }
    ValidateMobileOtp(model: any): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.ValidateMobileOtp, model).toPromise();
    }
}